module.exports = __webpack_public_path__ + "img/lachstempuramakifront.dbe4b7c7.jpg";